export default __webpack_public_path__ + "static/media/arrows-ascending.34fea20c.svg";